import type {
    ConfigField,
    CsvExportColumnCategory,
} from "app/pages/sales-intelligence/modules/enrichment/types/columns";
import type { LeadsColumnTypeDto } from "app/pages/sales-intelligence/modules/leads-search";
import type { ParsedContactsResult } from "app/pages/sales-intelligence/sub-modules/management/components/types";

export type EnrichmentPreview = {
    totalRows: number;
    matchedRows: number;
};

export type FieldItem = {
    id: string;
    field: ConfigField;
    label: string;
    additionalLabel?: string;
};

export type ColumnsConfigType = {
    name: CsvExportColumnCategory;
    labelKey: string;
    fields: readonly FieldItem[];
};

export enum EnrichmentStatus {
    Succeeded = 1,
    InProgress = 2,
    Failed = 3,
}

export type PostCsvProps = {
    domainFieldName: string;
    country: number;
    file: File;
    columns: readonly ConfigField[];
};

export type PostContactsCsvProps = {
    columns: Partial<Record<CsvExportColumnCategory, readonly ConfigField[]>>;
    allSelectedColumnsLength: number;
    parsingResult: Pick<ParsedContactsResult, "fileParsed" | "headerNames" | "totalRowCount">;
};

export type PostContactsCsvPropsFormData = {
    selectedColumns: string[];
    accountSelectedColumns: string[];
    headers: { key: string; label: string }[];
    rows: string[][];
    fileName: string;
};

export type EnrichedState = {
    id: string;
    fileName: string;
    created: string;
    domainsCount: number;
    enrichedDomainsCount: number;
    status: EnrichmentStatus;
    enrichmentTypeName: "Contacts" | "Leads";
    contactsCount: number;
    enrichedContactsCount: number;
};

export type EnrichmentErrorState = {
    error: string;
    id: string | null;
};

export type ContactsEnrichmentSelectedColumns = {
    selectedColumns: string[];
    accountSelectedColumns: string[];
};

export type EnrichmentConfigItem = { alias: string; name: string; type: LeadsColumnTypeDto };
